import { type PostMessage } from '@/types/PostMessageEvents.ts';

export const OAUTH_RETURN_TO_SESSION_KEY = 'oauth_return_to';
export const EMBED_ENTRY_QUERY_SESSION_KEY = 'embed_entry_query';

export function isEmbedded(): boolean {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
}

export function notifyEmbedderLoginSuccess(): void {
  window.parent.postMessage(
    {
      type: 'onSuccessLogin',
      payload: true,
    } satisfies PostMessage,
    '*',
  );
}

export function preSaveEmbedEntryQuery(): void {
  if (!isEmbedded() || !window.location.search) {
    return;
  }

  sessionStorage.setItem(EMBED_ENTRY_QUERY_SESSION_KEY, window.location.search);
}

export function readEmbedEntryParams(currentParams: URLSearchParams): URLSearchParams {
  const entryQuery = sessionStorage.getItem(EMBED_ENTRY_QUERY_SESSION_KEY);

  if (!entryQuery) {
    return currentParams;
  }

  const params = new URLSearchParams(entryQuery);
  currentParams.forEach((value, key) => params.set(key, value));

  return params;
}

export function isAllowedOAuthReturnUrl(returnTo: string, allowedUrls: readonly string[]): boolean {
  try {
    const target = new URL(returnTo);

    return allowedUrls.some((allowedUrl) => {
      if (!allowedUrl) {
        return false;
      }

      return target.origin === new URL(allowedUrl).origin;
    });
  } catch {
    return false;
  }
}

export function storeOAuthReturnTo(returnTo: string): void {
  sessionStorage.setItem(OAUTH_RETURN_TO_SESSION_KEY, returnTo);
}

export function takeOAuthReturnTo(): string | null {
  const returnTo = sessionStorage.getItem(OAUTH_RETURN_TO_SESSION_KEY);
  sessionStorage.removeItem(OAUTH_RETURN_TO_SESSION_KEY);

  return returnTo;
}
